import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, forwardRef, useState, useCallback, useEffect, useImperativeHandle, Children } from 'react';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

var hasRequiredClassnames;

function requireClassnames () {
	if (hasRequiredClassnames) return classnames.exports;
	hasRequiredClassnames = 1;
	(function (module) {
		/* global define */

		(function () {

			var hasOwn = {}.hasOwnProperty;

			function classNames () {
				var classes = '';

				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (arg) {
						classes = appendClass(classes, parseValue(arg));
					}
				}

				return classes;
			}

			function parseValue (arg) {
				if (typeof arg === 'string' || typeof arg === 'number') {
					return arg;
				}

				if (typeof arg !== 'object') {
					return '';
				}

				if (Array.isArray(arg)) {
					return classNames.apply(null, arg);
				}

				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					return arg.toString();
				}

				var classes = '';

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes = appendClass(classes, key);
					}
				}

				return classes;
			}

			function appendClass (value, newClass) {
				if (!newClass) {
					return value;
				}
			
				if (value) {
					return value + ' ' + newClass;
				}
			
				return value + newClass;
			}

			if (module.exports) {
				classNames.default = classNames;
				module.exports = classNames;
			} else {
				window.classNames = classNames;
			}
		}()); 
	} (classnames));
	return classnames.exports;
}

var classnamesExports = requireClassnames();
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

const NextButton = ({ onClick, isHidden, direction }) => {
    return (jsx("button", { "aria-label": "Next slide", type: "button", onClick: onClick, "aria-hidden": isHidden, className: classNames([
            'slider__button',
            'slider__button__next',
            {
                'slider__button--hidden': isHidden,
                'slider__button__next--horizontal': direction === Orientation.HORIZONTAL,
                'slider__button__next--vertical': direction === Orientation.VERTICAL,
            },
        ]), children: jsx("svg", { className: "slider__button__icon", xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 256 256", children: jsx("path", { d: "M96,216a8.5,8.5,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L164.7,128,90.3,53.7a8.1,8.1,0,0,1,11.4-11.4l80,80a8.1,8.1,0,0,1,0,11.4l-80,80A8.5,8.5,0,0,1,96,216Z" }) }) }));
};

const PreviousButton = ({ onClick, isHidden, direction }) => {
    return (jsx("button", { "aria-label": "Previous slide", type: "button", onClick: onClick, "aria-hidden": isHidden, className: classNames([
            'slider__button',
            'slider__button__prev',
            {
                'slider__button--hidden': isHidden,
                'slider__button__prev--horizontal': direction === Orientation.HORIZONTAL,
                'slider__button__prev--vertical': direction === Orientation.VERTICAL,
            },
        ]), children: jsx("svg", { className: "slider__button__icon", xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 256 256", children: jsx("path", { d: "M160,216a8.5,8.5,0,0,1-5.7-2.3l-80-80a8.1,8.1,0,0,1,0-11.4l80-80a8.1,8.1,0,0,1,11.4,11.4L91.3,128l74.4,74.3a8.1,8.1,0,0,1,0,11.4A8.5,8.5,0,0,1,160,216Z" }) }) }));
};

var Visibility;
(function (Visibility) {
    Visibility[Visibility["FULL"] = 0] = "FULL";
    Visibility[Visibility["PARTIAL"] = 1] = "PARTIAL";
    Visibility[Visibility["NONE"] = 2] = "NONE";
})(Visibility || (Visibility = {}));
var NavigationDirection;
(function (NavigationDirection) {
    NavigationDirection[NavigationDirection["PREV"] = 0] = "PREV";
    NavigationDirection[NavigationDirection["NEXT"] = 1] = "NEXT";
})(NavigationDirection || (NavigationDirection = {}));
const useSlider = () => {
    const visibleSlideIndices = useRef([]);
    const partiallyVisibleSlideIndices = useRef([]);
    const getFirstVisibleSlideIndex = () => visibleSlideIndices.current[0] ?? partiallyVisibleSlideIndices.current[0] ?? -1;
    const getLastVisibleSlideIndex = () => visibleSlideIndices.current[visibleSlideIndices.current.length - 1]
        ?? partiallyVisibleSlideIndices.current[partiallyVisibleSlideIndices.current.length - 1] ?? -1;
    const addVisibleSlide = (index) => visibleSlideIndices.current.push(index);
    const addPartiallyVisibleSlide = (index) => partiallyVisibleSlideIndices.current.push(index);
    const removePartiallyVisibleSlide = (index) => partiallyVisibleSlideIndices.current = partiallyVisibleSlideIndices.current.filter((slideIndex) => slideIndex !== index);
    const removeVisibleSlide = (index) => visibleSlideIndices.current = visibleSlideIndices.current.filter((slideIndex) => slideIndex !== index);
    const sortSlides = () => {
        visibleSlideIndices.current = [...new Set(visibleSlideIndices.current)].sort((a, b) => a - b);
        partiallyVisibleSlideIndices.current = [...new Set(partiallyVisibleSlideIndices.current)].sort((a, b) => a - b);
    };
    const shouldBlockClicks = (delta) => {
        return Math.abs(delta) > 5;
    };
    const getPositionToScrollTo = (direction, slideOffset, wrapperOffset, wrapperDimension, slideDimension) => {
        let scroll = 0;
        if (direction === NavigationDirection.PREV) {
            scroll = slideOffset - wrapperOffset - wrapperDimension + slideDimension;
        }
        else {
            scroll = slideOffset - wrapperOffset;
        }
        return scroll;
    };
    const getVisibilityByIntersectionRatio = (intersectionRatio) => {
        if (intersectionRatio >= 0.9) {
            return Visibility.FULL;
        }
        if (intersectionRatio >= 0.5) {
            return Visibility.PARTIAL;
        }
        return Visibility.NONE;
    };
    return {
        addVisibleSlide,
        addPartiallyVisibleSlide,
        removePartiallyVisibleSlide,
        removeVisibleSlide,
        sortSlides,
        getFirstVisibleSlideIndex,
        getLastVisibleSlideIndex,
        getPositionToScrollTo,
        getVisibilityByIntersectionRatio,
        shouldBlockClicks,
    };
};

var Orientation;
(function (Orientation) {
    Orientation["HORIZONTAL"] = "horizontal";
    Orientation["VERTICAL"] = "vertical";
})(Orientation || (Orientation = {}));
const Slider = forwardRef(({ children, hideNavigationButtons = false, initialSlideIndex = 0, onSlide = () => null, orientation = Orientation.HORIZONTAL, }, ref) => {
    const slides = useRef([]);
    const wrapper = useRef(null);
    const [nextArrowVisible, setNextArrowVisible] = useState(false);
    const [prevArrowVisible, setPrevArrowVisible] = useState(false);
    const [isScrollable, setIsScrollable] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [isBlockingClicks, setIsBlockingClicks] = useState(false);
    const [showNavigationButtons, setShowNavigationButtons] = useState(!hideNavigationButtons);
    const mousePosition = useRef({
        clientX: 0,
        clientY: 0,
        scrollX: 0,
        scrollY: 0,
    });
    const { getPositionToScrollTo, getVisibilityByIntersectionRatio, addVisibleSlide, addPartiallyVisibleSlide, getLastVisibleSlideIndex, sortSlides, getFirstVisibleSlideIndex, removeVisibleSlide, removePartiallyVisibleSlide, shouldBlockClicks, } = useSlider();
    const blockChildClickHandler = (event) => {
        if (isBlockingClicks) {
            event.stopPropagation();
            event.preventDefault();
        }
        setIsBlockingClicks(false);
    };
    const mouseUpHandler = () => setIsDragging(false);
    const mouseDownHandler = (event) => {
        mousePosition.current = {
            ...mousePosition,
            clientX: event.clientX,
            clientY: event.clientY,
            scrollX: wrapper.current?.scrollLeft ?? 0,
            scrollY: wrapper.current?.scrollTop ?? 0,
        };
        setIsDragging(true);
    };
    const mouseMoveHandler = (event) => {
        const currentWrapper = wrapper.current;
        const currentMousePosition = mousePosition.current;
        if (!currentWrapper || !isDragging) {
            return;
        }
        switch (orientation) {
            case Orientation.HORIZONTAL:
                if (shouldBlockClicks(currentMousePosition.clientX - event.clientX)) {
                    setIsBlockingClicks(true);
                }
                currentWrapper.scrollLeft = currentMousePosition.scrollX + currentMousePosition.clientX - event.clientX;
                break;
            case Orientation.VERTICAL:
                if (shouldBlockClicks(currentMousePosition.clientY - event.clientY)) {
                    setIsBlockingClicks(true);
                }
                currentWrapper.scrollTop = currentMousePosition.scrollY + currentMousePosition.clientY - event.clientY;
                break;
        }
    };
    const scrollToSlide = (index, behavior) => {
        const targetSlide = slides.current[index];
        const currentWrapper = wrapper.current;
        if (!targetSlide || !currentWrapper) {
            return;
        }
        const navDirection = (index >= getFirstVisibleSlideIndex()) ? NavigationDirection.NEXT : NavigationDirection.PREV;
        let scrollLeft = undefined;
        let scrollTop = undefined;
        switch (orientation) {
            case Orientation.HORIZONTAL:
                scrollLeft = getPositionToScrollTo(navDirection, targetSlide.element.offsetLeft, currentWrapper.offsetLeft, currentWrapper.clientWidth, targetSlide.element.clientWidth);
                break;
            case Orientation.VERTICAL:
                scrollTop = getPositionToScrollTo(navDirection, targetSlide.element.offsetTop, currentWrapper.offsetTop, currentWrapper.clientHeight, targetSlide.element.clientHeight);
                break;
        }
        const scrollOptions = {
            behavior,
            ...(Number.isInteger(scrollLeft) && { left: scrollLeft }),
            ...(Number.isInteger(scrollTop) && { top: scrollTop }),
        };
        currentWrapper.scrollTo(scrollOptions);
    };
    const navigate = (navDirection) => {
        const currentWrapper = wrapper.current;
        if (!currentWrapper) {
            return;
        }
        const targetSlideIndex = navDirection === NavigationDirection.PREV ? getFirstVisibleSlideIndex() - 1 : getLastVisibleSlideIndex() + 1;
        scrollToSlide(targetSlideIndex, 'smooth');
    };
    const setControlsVisibility = useCallback(() => {
        const lastSlideFullyVisible = getLastVisibleSlideIndex() + 1 === slides.current.length;
        const isPrevArrowVisible = getFirstVisibleSlideIndex() > 0 && isScrollable;
        const isNextArrowVisible = isScrollable && !lastSlideFullyVisible;
        if (!isPrevArrowVisible && !isNextArrowVisible) {
            setShowNavigationButtons(false);
        }
        else {
            setPrevArrowVisible(isPrevArrowVisible);
            setNextArrowVisible(isNextArrowVisible);
            setShowNavigationButtons(true);
        }
    }, [getFirstVisibleSlideIndex, getLastVisibleSlideIndex, isScrollable]);
    const checkScrollable = useCallback(() => {
        const currentWrapper = wrapper.current;
        if (!currentWrapper) {
            return;
        }
        setIsScrollable(orientation === Orientation.VERTICAL ? currentWrapper.scrollHeight > currentWrapper.clientHeight : currentWrapper.scrollWidth > currentWrapper.clientWidth);
    }, [orientation]);
    useEffect(() => {
        const currentWrapper = wrapper.current;
        if (!currentWrapper) {
            return () => { };
        }
        window?.addEventListener('resize', checkScrollable);
        checkScrollable();
        return () => {
            window?.removeEventListener('resize', checkScrollable);
        };
    });
    useEffect(() => {
        const currentWrapper = wrapper.current;
        if (!currentWrapper || !initialSlideIndex) {
            return;
        }
        const targetSlide = slides.current[initialSlideIndex];
        if (!targetSlide) {
            return;
        }
        let scrollLeft = undefined;
        let scrollTop = undefined;
        switch (orientation) {
            case Orientation.HORIZONTAL:
                scrollLeft = targetSlide.element.offsetLeft - currentWrapper.offsetLeft;
                break;
            case Orientation.VERTICAL:
                scrollTop = targetSlide.element.offsetTop - currentWrapper.offsetTop;
                break;
        }
        const scrollOptions = {
            behavior: 'instant',
            ...(Number.isInteger(scrollLeft) && { left: scrollLeft }),
            ...(Number.isInteger(scrollTop) && { top: scrollTop }),
        };
        currentWrapper.scrollTo(scrollOptions);
    }, [wrapper, initialSlideIndex, orientation]);
    useEffect(() => {
        const onDocumentMouseUp = (event) => {
            event.stopPropagation();
            event.preventDefault();
            setIsBlockingClicks(false);
            setIsDragging(false);
        };
        if (isDragging) {
            document?.addEventListener('mouseup', onDocumentMouseUp);
        }
        return () => {
            document?.removeEventListener('mouseup', onDocumentMouseUp);
        };
    }, [isDragging]);
    useEffect(() => {
        const currentWrapper = wrapper.current;
        if (!currentWrapper) {
            return () => { };
        }
        const intersectionCallback = (entries) => {
            entries.forEach((entry) => {
                const target = entry.target;
                const index = Number(target.dataset.slideIndex);
                const visibility = getVisibilityByIntersectionRatio(entry.intersectionRatio);
                visibility === Visibility.FULL ? addVisibleSlide(index) : removeVisibleSlide(index);
                visibility === Visibility.PARTIAL ? addPartiallyVisibleSlide(index) : removePartiallyVisibleSlide(index);
            });
            sortSlides();
            if (!hideNavigationButtons) {
                setControlsVisibility();
            }
            onSlide();
        };
        const intersectionObserver = new IntersectionObserver(intersectionCallback, {
            root: currentWrapper,
            threshold: [0, 0.5, 0.9, 1],
        });
        slides.current.forEach(({ element }) => intersectionObserver.observe(element));
        return () => intersectionObserver.disconnect();
    }, [
        wrapper,
        setControlsVisibility,
        hideNavigationButtons,
        sortSlides,
        addVisibleSlide,
        removeVisibleSlide,
        addPartiallyVisibleSlide,
        removePartiallyVisibleSlide,
        getVisibilityByIntersectionRatio,
        onSlide,
    ]);
    const scrollToNextSlide = () => navigate(NavigationDirection.NEXT);
    const scrollToPreviousSlide = () => navigate(NavigationDirection.PREV);
    useImperativeHandle(ref, () => ({
        scrollToSlide: scrollToSlide,
        scrollToNextSlide: scrollToNextSlide,
        scrollToPreviousSlide: scrollToPreviousSlide,
        getFirstFullyVisibleSlideIndex: getFirstVisibleSlideIndex,
        getLastFullyVisibleSlideIndex: getLastVisibleSlideIndex,
    }));
    const addSlide = (node, index) => {
        slides.current[index] = {
            element: node,
            visibility: Visibility.NONE,
        };
        checkScrollable();
    };
    return (jsxs("div", { className: "slider", children: [jsx("div", { role: "list", ref: wrapper, onMouseDown: mouseDownHandler, onMouseMove: mouseMoveHandler, onMouseUp: mouseUpHandler, onClickCapture: blockChildClickHandler, className: classNames('slider__wrapper', {
                    'slider__wrapper--is-scrollable': isScrollable,
                    'slider__wrapper--is-dragging': isDragging,
                    'slider__wrapper--is-horizontal': orientation === Orientation.HORIZONTAL,
                    'slider__wrapper--is-vertical': orientation === Orientation.VERTICAL,
                }), children: Children.map(children, (child, index) => (jsx("div", { className: "slider__wrapper__slide", role: "listitem", "data-slide-index": index, ref: (node) => { if (node) {
                        addSlide(node, index);
                    } }, children: child }, index))) }), showNavigationButtons && (jsxs(Fragment, { children: [jsx(PreviousButton, { onClick: scrollToPreviousSlide, isHidden: !prevArrowVisible, direction: orientation }), jsx(NextButton, { onClick: scrollToNextSlide, isHidden: !nextArrowVisible, direction: orientation })] }))] }));
});

export { Slider };
//# sourceMappingURL=module.js.map
